import React from "react";
import { generateAffiliationLabel } from "../../utils/delegateAffiliation";
import { beddowsToDecimal } from "../../utils/lisk/utils/lisk/beddowsToDecimal";
import { Badge } from "reactstrap";
import moment from "moment";
import { fromLiskEpoch } from "../../utils/lisk/utils/lisk/time";
import { Link } from "react-router-dom";
import { hexToString } from "../../utils/strings/strings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sanitizeString } from "../../utils/strings/censor";

let elementStyle = {
  maxHeight: "4rem",
  padding: "10px",
  borderTop: "#ffffff1f 1px solid",
  color: "rgba(255,255,255,0.7)",
  transition: "all 0.4s ease-out",
  opacity: 1,
};

const txDirectionsDict = {
  in: "success",
  out: "danger",
  self: "dark",
};

interface Props {
  id: string;
  timestamp: string;
  sender: string;
  senderId: string;
  recipient: string;
  recipientId: string;
  amount: string;
  fee: string;
  confirmations: number;
  senderAffiliation: string;
  recipientAffiliation: string;
  addressContext: string;
  transferData: string;
  type: number;
  setAddressContextReact: (address: string) => void;
}

export const TXElement: React.FC<Props> = ({
  id,
  timestamp,
  sender,
  senderId,
  recipient,
  recipientId,
  amount,
  fee,
  confirmations,
  senderAffiliation,
  recipientAffiliation,
  addressContext,
  transferData,
  type,
  setAddressContextReact,
}) => {
  const senderAffiliationLabels = generateAffiliationLabel(senderAffiliation);
  const recipientAffiliationLabels = generateAffiliationLabel(
    recipientAffiliation
  );
  let txDirection: "in" | "out" | "self" =
    senderId === addressContext ? "out" : "in";
  txDirection =
    senderId === addressContext && recipientId === addressContext
      ? "self"
      : txDirection;
  const hasDataIcon = !!transferData ? "fas" : "far";

  let realRecipient: any = null;
  switch (type) {
    case 0:
      realRecipient = recipientAffiliationLabels;
      break;
    case 1:
      realRecipient = "Second signature creation";
      break;
    case 2:
      realRecipient = "Delegate registration";
      break;
    case 3:
      realRecipient = "Delegate vote";
      break;
    case 4:
      realRecipient = "Multisig registration";
      break;
    default:
      realRecipient = "unsupported transaction";
  }

  return (
    <tr>
      <th scope="row" className={txDirectionsDict[txDirection]}>
        <FontAwesomeIcon
          data-tip={sanitizeString(hexToString(transferData))}
          className="fa"
          icon={[hasDataIcon, "comment"]}
          style={{ marginRight: 12, fontSize: "small" }}
        />
        <Link to={`/transaction/${id}`}>{id}</Link>
      </th>
      <td>
        {moment(fromLiskEpoch(+timestamp)).format("D/MM/YYYY - HH:mm:ss")}
      </td>
      <td>
        {txDirection === "in" ? (
          <Link
            to={`/account/${senderId}`}
            onClick={() => setAddressContextReact(sender)}
          >
            {sender}
          </Link>
        ) : (
          <strong>{sender}</strong>
        )}{" "}
        {senderAffiliationLabels}
      </td>
      <td>
        {txDirection === "out" && type === 0 ? (
          <Link
            to={`/account/${recipientId}`}
            onClick={() => setAddressContextReact(recipient)}
          >
            {recipient}
          </Link>
        ) : (
          <strong>{type === 0 ? recipient : realRecipient}</strong>
        )}{" "}
      </td>
      <td>
        <Badge
          className={`badge-${txDirectionsDict[txDirection]}`}
          style={{ fontSize: "medium" }}
        >
          {+beddowsToDecimal(amount).toLocaleString()} Ⱡ
        </Badge>
      </td>
      <td>{(+beddowsToDecimal(fee)).toLocaleString()} Ⱡ</td>
      <td>{confirmations}</td>
    </tr>
  );
};
